export default __webpack_public_path__ + "static/media/pgmlogo.74eb1e3b.png";